function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-storage {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic-storage",
  transform: "translate(0.375 0.53)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15761",
  "data-name": "Group 15761"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_15760",
  "data-name": "Group 15760"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9534",
  "data-name": "Path 9534",
  className: "cls-storage",
  d: "M589.253,1275.588l.009.009a6.548,6.548,0,0,0,4.63,1.918h2.279v9.539a4.383,4.383,0,0,1-2.557,3.985l-4.543,2.083-4.436-2.161a4.382,4.382,0,0,1-2.464-3.941v-9.5h2.441a6.551,6.551,0,0,0,4.64-1.928h0",
  transform: "translate(-582.171 -1275.588)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_15762",
  "data-name": "Group 15762",
  transform: "translate(2.174 3.534)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_529",
  "data-name": "Line 529",
  className: "cls-storage",
  x1: 0.001,
  y2: 4.43,
  transform: "translate(4.825 5.123)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9535",
  "data-name": "Path 9535",
  className: "cls-storage",
  d: "M585.346,1283.052v4.572l4.023,1.849.057.026,3.964-1.82v-4.628",
  transform: "translate(-584.543 -1279.947)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9536",
  "data-name": "Path 9536",
  className: "cls-storage",
  d: "M593.39,1283.053l-4.022,2.017-4.023-2.017",
  transform: "translate(-584.543 -1279.947)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9537",
  "data-name": "Path 9537",
  className: "cls-storage",
  d: "M593.39,1282.606l-4.022-2.24-4.023,2.24",
  transform: "translate(-584.543 -1279.5)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_530",
  "data-name": "Line 530",
  className: "cls-storage",
  x2: 4.03,
  y2: 2.127,
  transform: "translate(2.856 1.963)"
})));

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.75,
    height: 18.439,
    viewBox: "0 0 14.75 18.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.89f5be47.svg";
export { ForwardRef as ReactComponent };